import React from 'react'
import './index.sass'

export const CasesSlider = ({ slides, handleChangeSlide, activeIndex }) => {
  return (
    <div className="cases-slider">
      {slides.map((el, ind) => (
        <div
					key={el.id}
          className={
            activeIndex === ind ? 'cases-slider-wrapper cases-slider-wrapper-active' : 'cases-slider-wrapper'
          }
          onClick={() => handleChangeSlide(ind)}
        >
          <img alt={el.thumbnailUrl} src={el.thumbnailUrl} />
        </div>
      ))}
    </div>
  )
}
